<template>
  <div>
    <v-dialog v-model="showModalCamposExtra" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline">Campos Extra</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="my-5 d-flex flex-column" style="gap: 16px">
          <template v-for="campo in camposExtra">
            <v-text-field
              :key="campo.propriedade"
              v-if="!!campo.mascara"
              hide-details="auto"
              outlined
              :label="campo.descricao"
              v-model="vModels[campo.propriedade]"
              v-mask="campo.mascara"
            ></v-text-field>

            <v-text-field
              v-else
              :key="campo.propriedade"
              hide-details="auto"
              outlined
              :label="campo.descricao"
              v-model="vModels[campo.propriedade]"
            ></v-text-field>
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="red" dark @click="fechar">Fechar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green" :dark="!!allFieldsFilled" @click="downloadRelatorio" :disabled="!allFieldsFilled"
            >Baixar Relatório</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  name: "ModalCamposExtra",

  directives: { mask },

  props: {
    showModalCamposExtra: Boolean,
    camposExtra: Array,
    relatorio: Object,
  },

  data() {
    return {
      vModels: {},
    };
  },

  methods: {
    fechar() {
      this.vModels = {};
      this.$emit("fecharModal");
    },

    downloadRelatorio() {
      this.$emit("download", this.relatorio, this.vModels);
      this.fechar();
    },
  },

  computed: {
    allFieldsFilled() {
      return (
        Object.keys(this.vModels).length === this.camposExtra.length &&
        Object.values(this.vModels).every((value) => value.trim() !== "")
      );
    },
  },

  watch: {
    camposExtra: {
      immediate: true,
      handler(newCampos) {
        this.vModels = newCampos.reduce((acc, campo) => {
          acc[campo.propriedade] = "";
          return acc;
        }, {});
      },
    },
  },
};
</script>

<style scoped></style>
